// Action type constants for the Product Catalog Control Center AI chatbot (Brisque AI).
// Namespaced under `productCatalog/chatbot/` so they never collide with the
// reports chatbot slice (`reports/chatbot/`).

// ── Conversation: create / resume (§4.1) ───────────────────────────────────────
export const CREATE_CONVERSATION_REQUEST = 'productCatalog/chatbot/CREATE_CONVERSATION_REQUEST';
export const CREATE_CONVERSATION_SUCCESS = 'productCatalog/chatbot/CREATE_CONVERSATION_SUCCESS';
export const CREATE_CONVERSATION_FAILURE = 'productCatalog/chatbot/CREATE_CONVERSATION_FAILURE';

// ── Conversation list / sidebar (§4.2) ──────────────────────────────────────────
export const LIST_CONVERSATIONS_REQUEST = 'productCatalog/chatbot/LIST_CONVERSATIONS_REQUEST';
export const LIST_CONVERSATIONS_SUCCESS = 'productCatalog/chatbot/LIST_CONVERSATIONS_SUCCESS';
export const LIST_CONVERSATIONS_FAILURE = 'productCatalog/chatbot/LIST_CONVERSATIONS_FAILURE';

// ── Load one thread's history (§4.3) ────────────────────────────────────────────
export const LOAD_CONVERSATION_REQUEST = 'productCatalog/chatbot/LOAD_CONVERSATION_REQUEST';
export const LOAD_CONVERSATION_SUCCESS = 'productCatalog/chatbot/LOAD_CONVERSATION_SUCCESS';
export const LOAD_CONVERSATION_FAILURE = 'productCatalog/chatbot/LOAD_CONVERSATION_FAILURE';

// ── Send a message (§4.4) ───────────────────────────────────────────────────────
export const SEND_MESSAGE_REQUEST = 'productCatalog/chatbot/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'productCatalog/chatbot/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'productCatalog/chatbot/SEND_MESSAGE_FAILURE';

// ── Rename / delete thread (§4.5 / §4.6) ────────────────────────────────────────
export const RENAME_CONVERSATION_REQUEST = 'productCatalog/chatbot/RENAME_CONVERSATION_REQUEST';
export const RENAME_CONVERSATION_SUCCESS = 'productCatalog/chatbot/RENAME_CONVERSATION_SUCCESS';
export const RENAME_CONVERSATION_FAILURE = 'productCatalog/chatbot/RENAME_CONVERSATION_FAILURE';

export const DELETE_CONVERSATION_REQUEST = 'productCatalog/chatbot/DELETE_CONVERSATION_REQUEST';
export const DELETE_CONVERSATION_SUCCESS = 'productCatalog/chatbot/DELETE_CONVERSATION_SUCCESS';
export const DELETE_CONVERSATION_FAILURE = 'productCatalog/chatbot/DELETE_CONVERSATION_FAILURE';

// ── Action card: confirm / cancel / pick / edit (§4.7 / §6) ─────────────────────
export const CONFIRM_CARD_REQUEST = 'productCatalog/chatbot/CONFIRM_CARD_REQUEST';
export const CONFIRM_CARD_SUCCESS = 'productCatalog/chatbot/CONFIRM_CARD_SUCCESS';
export const CONFIRM_CARD_FAILURE = 'productCatalog/chatbot/CONFIRM_CARD_FAILURE';

export const CANCEL_CARD_REQUEST = 'productCatalog/chatbot/CANCEL_CARD_REQUEST';
export const CANCEL_CARD_SUCCESS = 'productCatalog/chatbot/CANCEL_CARD_SUCCESS';
export const CANCEL_CARD_FAILURE = 'productCatalog/chatbot/CANCEL_CARD_FAILURE';

export const PICK_CANDIDATE_REQUEST = 'productCatalog/chatbot/PICK_CANDIDATE_REQUEST';
export const PICK_CANDIDATE_SUCCESS = 'productCatalog/chatbot/PICK_CANDIDATE_SUCCESS';
export const PICK_CANDIDATE_FAILURE = 'productCatalog/chatbot/PICK_CANDIDATE_FAILURE';

export const SET_CARD_CHANNELS_REQUEST = 'productCatalog/chatbot/SET_CARD_CHANNELS_REQUEST';
export const SET_CARD_CHANNELS_SUCCESS = 'productCatalog/chatbot/SET_CARD_CHANNELS_SUCCESS';
export const SET_CARD_CHANNELS_FAILURE = 'productCatalog/chatbot/SET_CARD_CHANNELS_FAILURE';

export const SET_CARD_DURATION_REQUEST = 'productCatalog/chatbot/SET_CARD_DURATION_REQUEST';
export const SET_CARD_DURATION_SUCCESS = 'productCatalog/chatbot/SET_CARD_DURATION_SUCCESS';
export const SET_CARD_DURATION_FAILURE = 'productCatalog/chatbot/SET_CARD_DURATION_FAILURE';

export const REMOVE_CARD_ROW_REQUEST = 'productCatalog/chatbot/REMOVE_CARD_ROW_REQUEST';
export const REMOVE_CARD_ROW_SUCCESS = 'productCatalog/chatbot/REMOVE_CARD_ROW_SUCCESS';
export const REMOVE_CARD_ROW_FAILURE = 'productCatalog/chatbot/REMOVE_CARD_ROW_FAILURE';

// ── Channels list (§4.8) ────────────────────────────────────────────────────────
export const FETCH_CHANNELS_REQUEST = 'productCatalog/chatbot/FETCH_CHANNELS_REQUEST';
export const FETCH_CHANNELS_SUCCESS = 'productCatalog/chatbot/FETCH_CHANNELS_SUCCESS';
export const FETCH_CHANNELS_FAILURE = 'productCatalog/chatbot/FETCH_CHANNELS_FAILURE';

// ── Sync (§4.9 / §7) ────────────────────────────────────────────────────────────
export const RUN_SYNC_REQUEST = 'productCatalog/chatbot/RUN_SYNC_REQUEST';
export const RUN_SYNC_SUCCESS = 'productCatalog/chatbot/RUN_SYNC_SUCCESS';
export const RUN_SYNC_FAILURE = 'productCatalog/chatbot/RUN_SYNC_FAILURE';

export const SYNC_RESULTS_REQUEST = 'productCatalog/chatbot/SYNC_RESULTS_REQUEST';
export const SYNC_RESULTS_SUCCESS = 'productCatalog/chatbot/SYNC_RESULTS_SUCCESS';
export const SYNC_RESULTS_FAILURE = 'productCatalog/chatbot/SYNC_RESULTS_FAILURE';

export const SYNC_RETRY_REQUEST = 'productCatalog/chatbot/SYNC_RETRY_REQUEST';
export const SYNC_RETRY_SUCCESS = 'productCatalog/chatbot/SYNC_RETRY_SUCCESS';
export const SYNC_RETRY_FAILURE = 'productCatalog/chatbot/SYNC_RETRY_FAILURE';

// ── Activity log & undo (§4.10 / §8) ────────────────────────────────────────────
export const FETCH_LOG_REQUEST = 'productCatalog/chatbot/FETCH_LOG_REQUEST';
export const FETCH_LOG_SUCCESS = 'productCatalog/chatbot/FETCH_LOG_SUCCESS';
export const FETCH_LOG_FAILURE = 'productCatalog/chatbot/FETCH_LOG_FAILURE';

export const UNDO_LOG_ENTRY_REQUEST = 'productCatalog/chatbot/UNDO_LOG_ENTRY_REQUEST';
export const UNDO_LOG_ENTRY_SUCCESS = 'productCatalog/chatbot/UNDO_LOG_ENTRY_SUCCESS';
export const UNDO_LOG_ENTRY_FAILURE = 'productCatalog/chatbot/UNDO_LOG_ENTRY_FAILURE';

// ── Manual catalogue refresh (§4.11) ────────────────────────────────────────────
export const REFRESH_CATALOGUE_REQUEST = 'productCatalog/chatbot/REFRESH_CATALOGUE_REQUEST';
export const REFRESH_CATALOGUE_SUCCESS = 'productCatalog/chatbot/REFRESH_CATALOGUE_SUCCESS';
export const REFRESH_CATALOGUE_FAILURE = 'productCatalog/chatbot/REFRESH_CATALOGUE_FAILURE';

// ── Quick-action CTAs, served by the backend (§Item 6) ──────────────────────────
export const FETCH_CTAS_REQUEST = 'productCatalog/chatbot/FETCH_CTAS_REQUEST';
export const FETCH_CTAS_SUCCESS = 'productCatalog/chatbot/FETCH_CTAS_SUCCESS';
export const FETCH_CTAS_FAILURE = 'productCatalog/chatbot/FETCH_CTAS_FAILURE';

// ── Local view-only mutations ───────────────────────────────────────────────────
export const CHATBOT_SET_ACTIVE_CONVERSATION = 'productCatalog/chatbot/SET_ACTIVE_CONVERSATION';
export const CHATBOT_APPEND_LOCAL_MESSAGE = 'productCatalog/chatbot/APPEND_LOCAL_MESSAGE';
export const CHATBOT_RESET = 'productCatalog/chatbot/RESET';

// -- Staged "thinking" status text (local timing, no backend round-trip) --------
export const CHATBOT_THINKING_STATUS = 'productCatalog/chatbot/THINKING_STATUS'; // payload: string | null

// -- Sync countdown tick (local timing, saga-driven) -----------------------------
export const CHATBOT_SYNC_TICK = 'productCatalog/chatbot/SYNC_TICK'; // payload: { msgId: string; remaining: number }

// -- Optimistic card patch, applied instantly then reconciled/rolled back --------
export const CHATBOT_OPTIMISTIC_CARD_PATCH = 'productCatalog/chatbot/OPTIMISTIC_CARD_PATCH';

// -- Local first-message title prediction (server title lands on next reload) ---
export const CHATBOT_PREDICT_TITLE = 'productCatalog/chatbot/PREDICT_TITLE';

// -- Clear the undo confirmation message (activity log panel only) --------------
export const CHATBOT_CLEAR_UNDO_RESULT = 'productCatalog/chatbot/CLEAR_UNDO_RESULT';

// -- Consume the "undo succeeded, route to this thread" signal ------------------
// Set by UNDO_LOG_ENTRY_SUCCESS when the backend returns `ok: true`; the shell closes
// the activity panel and clears the flag so it fires once per undo.
export const CHATBOT_CLEAR_UNDO_NAV = 'productCatalog/chatbot/CLEAR_UNDO_NAV';
